export const RouteConstant = {
    ROOT: '/',
    LOGIN: "/",
    DASHBOARD: "/dashboard",
    USERS: "/users",
    HOLIDAY: "/holiday",
    STATUSHISTORY: "/statushistory",
    LUNCH: "/lunch",
}